/**
 *  @class
 *  @function CountdownTimer
 */
if (!customElements.get('cbx-countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      // 从 data-* 属性读取
      const dateArr = this.dataset.date.split('-'),
            timeArr = this.dataset.time ? this.dataset.time.split(':') : ['0', '0'];

      const day = parseInt(dateArr[0], 10),
            month = parseInt(dateArr[1], 10),
            year = parseInt(dateArr[2], 10),
            hour = parseInt(timeArr[0], 10),
            minute = parseInt(timeArr[1], 10);

      // 用本地时间构造倒计时，iOS 兼容
      this.countDownDate = new Date(year, month - 1, day, hour, minute, 0).getTime();
    }

    connectedCallback() {
      // 查询 HTML 元素
      const daysEl = this.querySelector('.days .cbx-countdown-timer--column--number'),
            hoursEl = this.querySelector('.hours .cbx-countdown-timer--column--number'),
            minutesEl = this.querySelector('.minutes .cbx-countdown-timer--column--number'),
            secondsEl = this.querySelector('.seconds .cbx-countdown-timer--column--number');

      const updateTime = () => {
        const now = Date.now();
        let distance = this.countDownDate - now;

        if (distance <= 0) {
          daysEl.textContent = hoursEl.textContent = minutesEl.textContent = secondsEl.textContent = '00';
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24)),
              hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
              minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
              seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // 更新显示
        daysEl.textContent = CountdownTimer.addZero(days);
        hoursEl.textContent = CountdownTimer.addZero(hours);
        minutesEl.textContent = CountdownTimer.addZero(minutes);
        secondsEl.textContent = CountdownTimer.addZero(seconds);
      };

      // 每秒更新一次
      this.timerInterval = setInterval(updateTime, 1000);
      updateTime(); // 立即显示一次
    }

    disconnectedCallback() {
      // 移除定时器，避免内存泄漏
      clearInterval(this.timerInterval);
    }

    static addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }

  customElements.define('cbx-countdown-timer', CountdownTimer);
}
